import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';

export function makeEmotionCache(direction) {
  if (direction === 'rtl') {
    return createCache({ key: 'muirtl', stylisPlugins: [rtlPlugin] });
  }
  return createCache({ key: 'muiltr' });
}
